<template>
    <div class="footer-area-wrapper" :class="FooterStyle" id="footer">
        <div class="footer-area section-space--ptb_90">
            <div class="container">
                <div class="row footer-widget-wrapper">
                    <div class="col-lg-3 col-md-3 footer-widget">
                        <div class="footer-widget__logo mb-30">
                            <router-link to="/">
                                <img src="../assets/img/logo/logo-dark.png" class="img-fluid logo-dark" alt="">
                                <img src="../assets/img/logo/logo-light.png" class="img-fluid logo-light" alt="">
                            </router-link>
                        </div>
                    
                    </div>
                     <div class="col-lg-6 col-md-6 footer-widget">
                      
                    </div>   
                    <div class="col-lg-3 col-md-3 footer-widget">
                        <h6 class="footer-widget__title mb-20">Contact Us</h6>
                        <ul class="footer-widget__list">
                            <li> HSR, Bangalore- 560102</li>
                            <li><a href="#" class="hover-style-link">contact@roxorlabs.co</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-copyright-area border-top section-space--ptb_30">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-12 text-center text-md-center">
                        <span class="copyright-text">© 2020 Roxorlabs. All Rights Reserved.</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FooterMain',
        props: ["FooterStyle"]
    }
</script>